import React from 'react';

export default function clearRenderer() {
	return React.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/react-select/lib/utils/defaultClearRenderer.js
// module id = 2417
// module chunks = 69